// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { ChartMath} from "../Utils/ChartMath.js";
import { ToolView } from "./ToolView.js";

export let AndrewsPitchforkToolView = function (tool)
{
    ToolView.call(this, tool);
};

AndrewsPitchforkToolView.prototype = Object.create(ToolView.prototype);

AndrewsPitchforkToolView.prototype.IsSelectCheck = function (x, y)
{
    var TOOL_DX = ToolView.TOOL_DX;
    var screenPoints = this.screenPoints;
    var p0 = screenPoints[0];
    var p1 = screenPoints[1];
    var p2 = screenPoints[2];

    if ((ChartMath.CalcDistanceFromPointToSection(p0, p1, x, y) <= TOOL_DX) ||
        (ChartMath.CalcDistanceFromPointToSection(p0, p2, x, y) <= TOOL_DX))
        return true;

    return false;
};

AndrewsPitchforkToolView.prototype.Draw = function (gr, ww, param)
{
    var dataCacheTool = this.dataCacheTool;

    var pen = dataCacheTool.Pen;
    var penRay = dataCacheTool.PenRay;
    var ray = dataCacheTool.RayType;

    var screenPoints = this.screenPoints;

    var p0 = screenPoints[0];
    var x0 = p0[0];
    var y0 = p0[1];

    var p1 = screenPoints[1];
    var x1 = p1[0];
    var y1 = p1[1];

    var p2 = screenPoints[2];
    var x2 = p2[0];
    var y2 = p2[1];

    var yc = (y2 + y1) / 2;
    var xc = (x2 + x1) / 2;
    var dx = xc - x0;
    var dy = yc - y0;

    ToolView.DrawLineWithRay(gr, ww, x0, y0, xc, yc, ray, pen, penRay);
    ToolView.DrawLineWithRay(gr, ww, x1, y1, x1 + dx, y1 + dy, ray, pen, penRay);
    ToolView.DrawLineWithRay(gr, ww, x2, y2, x2 + dx, y2 + dy, ray, pen, penRay);

    ToolView.prototype.Draw.call(this, gr, ww, param);
};

AndrewsPitchforkToolView.prototype.DrawSelection = function (gr, ww)
{
    var dataCacheTool = this.dataCacheTool;

    var pen = dataCacheTool.Pen;
    var penRay = dataCacheTool.PenRay;
    var rayType = dataCacheTool.RayType;

    var screenPoints = this.screenPoints;

    var p0 = screenPoints[0];
    var x0 = p0[0];
    var y0 = p0[1];

    var p1 = screenPoints[1];
    var x1 = p1[0];
    var y1 = p1[1];

    var p2 = screenPoints[2];
    var x2 = p2[0];
    var y2 = p2[1];

    ToolView.DrawLineWithRay(gr, ww, x0, y0, x1, y1, rayType, pen, penRay);
    ToolView.DrawLineWithRay(gr, ww, x0, y0, x2, y2, rayType, pen, penRay);

    this.DrawSelectedPoint(gr, ww, x0, y0);
    this.DrawSelectedPoint(gr, ww, x1, y1);
    this.DrawSelectedPoint(gr, ww, x2, y2);

    this.DrawSelectedLine(gr, ww, x0, y0, x1, y1);
    this.DrawSelectedLine(gr, ww, x0, y0, x2, y2);
};